import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import Button from "../../../../components/common/button/Button";
import styles from "./Education.scss";
import { Form, FormGroup } from "react-bootstrap";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { getUserData, getUserDataById } from "../../../../actions/user.actions";
import AddBox from "../../completeProfile/components/AddBox";

class Education extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { memberId } = this.props;
    if (memberId) {
      this.props.getUserDataById(memberId);
    } else {
      this.props.getUserData();
    }
  }

  render() {
    const { submitting, valid } = this.props;

    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.education}>
          <div className={styles.content}>
            <h2 className={styles.title}>Education</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.subtitle}>
                    Show off your school spirit! Help companies select you for a
                    project by providing information about your education
                    history.
                  </div>
                </FormGroup>
                <FormGroup>
                  <div className={styles.dividerNoPadding} />

                  <AddBox
                    name="education"
                    optionName="school_id"
                    inputName="degree"
                    placeholder="Degree"
                    placeholderTypeahead="School"
                    options={this.props.schools}
                    text="Display additional schools..."
                    addText="Add another school + degree"
                    typeahead={true}
                    prefix="Add new School: "
                    isLoading={this.props.isLoadingSchools}
                    labelKey="value"
                    valueKey="school_id"
                    selectOpts={this.props.user && this.props.user.education}
                    allowNew={true}
                    focusOut={(query, selected, name) => {
                      if (
                        !selected ||
                        !Array.isArray(selected) ||
                        !selected.length
                      ) {
                        this.props.change(`${name}`, null);

                        if (query) {
                          this.props.change(`${name}[0].school_name`, query);
                        }
                      }
                    }}
                    onSearch={query => this.props.onSearchSchools(query)}
                  />
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Save Changes"
                    isLoading={this.props.saving}
                    loadingText="Saving..."
                    isDisabled={!valid || submitting || this.props.saving}
                  />
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

Education = reduxForm({
  form: "education",
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(Education);

Education = connect(
  state => {
    return {
      user: state.user.data,
      initialValues: state.user.data,
      saving: state.user.loading
    };
  },
  dispatch => {
    return {
      getUserData: () => dispatch(getUserData()),
      getUserDataById: id => dispatch(getUserDataById(id))
    };
  }
)(Education);

export default Education;



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/components/Education.js